var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7099 1.80714e-06H1.31268C0.935287 -0.000712046 0.589308 0.210112 0.416794 0.54586C0.241901 0.886128 0.272596 1.29588 0.496031 1.60664L8.33506 12.6494C8.33768 12.6532 8.34054 12.6568 8.34315 12.6606C8.62798 13.0451 8.78193 13.5108 8.78288 13.9896V22.9927C8.78122 23.2594 8.88592 23.5154 9.0739 23.7046C9.26188 23.8938 9.51744 23.9999 9.78394 23.9999C9.91957 23.9999 10.0535 23.9728 10.1787 23.9209L14.5836 22.2412C14.9784 22.1208 15.2404 21.7484 15.2404 21.2999V13.9896C15.2411 13.5111 15.3953 13.0451 15.6799 12.6606C15.6825 12.6568 15.6853 12.6532 15.688 12.6494L23.5268 1.60617C23.7502 1.29564 23.7809 0.886128 23.606 0.54586C23.4335 0.210112 23.0875 -0.000712046 22.7099 1.80714e-06ZM14.6976 11.9389C14.2598 12.5331 14.023 13.2514 14.0216 13.9896V21.1519L10.0012 22.6847V13.9896C9.99976 13.2514 9.763 12.5331 9.32493 11.9389L1.71457 1.21831H22.3082L14.6976 11.9389Z",
    fill: "#B7B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.06ede60197a89de573c1e0e40ef4d9a1.svg";
export { ForwardRef as ReactComponent };